import "./affiliation.css"
import aff_logo from "../../../assets/logo.svg"
import React from "react";
import {Link} from "react-router-dom";
import {setAffiliationField, setQuestions} from "../../../redux/affiliation_store";
import {setPersonalData} from "../../../redux/personal_store";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import axios from "axios";

function AffiliationInfo({affiliation, setQuestions, setAffiliationField, appData, personalData}) {

    const {t} = useTranslation()

    let linkTo = '/account'
    if (appData.account_type === 'custodial') linkTo = '/custodial-account'
    if (appData.account_type === 'speciality') linkTo = '/authorized-signers'

    const handleRadioChange = (questionId, value) => {
        const updatedQuestions = affiliation.questions.map((item) => {
            if (item.id === questionId) {
                return {...item, selected: value};
            }
            return item;
        });
        setQuestions(updatedQuestions);
    };

    const getAffiliationValues = (affiliation) => {
        const converter = (field) => {
            const item = affiliation.questions.find(el => el.name === field)

            return item?.selected ? 'Y' : 'N'
        }

        return {
            AffiliationMember: converter('AffiliationMember'),
            AffiliationBroker: converter('AffiliationBroker'),
            AffiliationForShellBank: converter('AffiliationForShellBank'),
            AffiliationShellBank: converter('AffiliationShellBank'),
            AffiliationShellBankService: converter('AffiliationShellBankService'),
            AffiliationBankrupt: converter('AffiliationBankrupt'),
            AffiliationLegal: converter('AffiliationLegal'),
            AffiliationUnpaid: converter('AffiliationUnpaid'),
            AffiliationOtherFunds: converter('AffiliationOtherFunds'),
            AffiliationFFI: converter('AffiliationFFI'),
            AffiliationPoliOfficial: converter('AffiliationPoliOfficial'),
            AffiliationPoliOfficialOrg: affiliation.organizations,
            AffiliationPoliOfficialName: affiliation.name,
            AffiliationMemberFirm: affiliation.memberCompanyName,
            AffiliationMemberName: affiliation.memberAffPerson,
            AffiliationMemberPosition: affiliation.memberPosition,
            AffiliationBrokerFirm: affiliation.companyName,
            AffiliationBrokerName: affiliation.affPerson,
            AffiliationBrokerPosition: affiliation.position,
            AffiliationForShellBankAgent: affiliation.process,
        };
    };

    const updateAffiliation = async () => {
        const URL = `${process.env.REACT_APP_API_URL}/api/accounts/step3/` + appData.app_id;
        const params = getAffiliationValues(affiliation);

        try {
            await axios.put(URL, params, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            });
        } catch (error) {
            console.error(error);
        }
    };


    const onSubmit = () => {
        updateAffiliation();
    }

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setAffiliationField(name, value);
    };

    return (
        <div className="affiliation">
            <div className="affiliation_left_side">
                <img src={aff_logo} alt=""/>
            </div>
            <div className="affiliation_right_side">
                <Logout/>
                <p className="affiliation_heading">{t('affiliation.welcome')} {personalData.firstName} {personalData.lastName}. {t('affiliation.affiliated')}</p>
                <p className="affiliation_info_heading">{t('affiliation.affiliation_information')}</p>
                <div className="affiliation_info">
                    {affiliation.questions.map((item, i) => {
                        return (
                            <div style={{paddingBottom: "8%"}} key={i}>
                                <p className="affiliation_question"> {t(item.text)}</p>
                                <div className="checkbox">
                                    <div className="checkbox_parts">
                                        <input
                                            type="radio"
                                            className="aff_checkbox"
                                            name={item.id}
                                            value="yes"
                                            id={item.id}
                                            checked={item.selected === true}
                                            onChange={(e) => handleRadioChange(item.id, true)}
                                        />
                                        <label htmlFor={item.id} className="aff_checkbox_text">
                                            {t('affiliation.yes')}
                                        </label>
                                    </div>
                                    <div className="checkbox_parts">
                                        <input
                                            type="radio"
                                            className="aff_checkbox"
                                            name={item.id}
                                            value="no"
                                            id={item.id}
                                            checked={item.selected === false}
                                            onChange={(e) => handleRadioChange(item.id, false)}
                                        />
                                        <label htmlFor={item.id} className="aff_checkbox_text">
                                            {t('affiliation.no')}
                                        </label>
                                    </div>
                                </div>
                                {item.id === 1 && item.selected === true && (
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                        paddingTop: "3%"
                                    }}>
                                        <div style={{display: "flex", flexWrap: "wrap", gap: "10px"}}>
                                            <input className="aff_inputs" type="text"
                                                   placeholder={t('affiliation.aff_company_name')}
                                                   name="memberCompanyName"
                                                   value={affiliation.memberCompanyName}
                                                   onChange={handleInputChange}
                                                   style={{width: "49%"}}
                                            />
                                            <input className="aff_inputs" type="text"
                                                   placeholder={t('affiliation.your_position')}
                                                   value={affiliation.memberPosition}
                                                   onChange={handleInputChange}
                                                   name="memberPosition"
                                                   style={{width: "49%"}}
                                            />
                                        </div>
                                        <input className="aff_inputs" type="text"
                                               name="memberAffPerson"
                                               value={affiliation.memberAffPerson}
                                               onChange={handleInputChange}
                                               placeholder={t('affiliation.aff_person_name')}
                                        />
                                    </div>
                                )}

                                {item.id === 2 && item.selected === true && (
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                        paddingTop: "3%"
                                    }}>
                                        <div style={{display: "flex", flexWrap: "wrap", gap: "10px"}}>
                                            <input className="aff_inputs" type="text"
                                                   placeholder={t('affiliation.aff_company_name')}
                                                   name="companyName"
                                                   value={affiliation.companyName}
                                                   onChange={handleInputChange}
                                                   style={{width: "49%"}}/>
                                            <input className="aff_inputs" type="text"
                                                   placeholder={t('affiliation.your_position')}
                                                   name="position"
                                                   value={affiliation.position}
                                                   onChange={handleInputChange}
                                                   style={{width: "49%"}}/>
                                        </div>
                                        <input className="aff_inputs" type="text"
                                               name="affPerson"
                                               value={affiliation.affPerson}
                                               onChange={handleInputChange}
                                               placeholder={t('affiliation.aff_person_name')}
                                        />
                                    </div>
                                )}

                                {item.id === 3 && item.selected === true && (
                                    <div style={{paddingTop: "3%"}}>
                                        <input className="aff_inputs" type="text"
                                               name="process"
                                               value={affiliation.process}
                                               onChange={handleInputChange}
                                               placeholder={t('affiliation.agent_list')}
                                        />
                                    </div>
                                )}

                                {item.id === 10 && item.selected === true && (
                                    <div style={{paddingTop: "3%"}}>
                                        <p style={{textAlign: "center"}}>{t('affiliation.financial_regulator')}</p>
                                    </div>
                                )}

                                {item.id === 11 && item.selected === true && (
                                    <div style={{paddingTop: "3%"}}>
                                        <p style={{textAlign: "center"}}>{t('affiliation.political_organization')}
                                        </p>
                                        <div style={{display: "flex", flexWrap: "wrap", gap: "10px"}}>
                                            <input className="aff_inputs" type="text"
                                                   placeholder={t('affiliation.name')}
                                                   name="name"
                                                   value={affiliation.name}
                                                   onChange={handleInputChange}
                                                   style={{width: "49%"}}/>
                                            <input className="aff_inputs" type="text"
                                                   placeholder={t('affiliation.organization')}
                                                   name="organizations"
                                                   value={affiliation.organizations}
                                                   onChange={handleInputChange}
                                                   style={{width: "49%"}}/>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                <div className="affiliation_btn">
                    <Link style={{textDecoration: "none"}} to="/financial">
                        <button className="affiliation_back_btn">{t('back_btn')}</button>
                    </Link>
                    <Link to={linkTo} style={{textDecoration: "none"}}>
                        <button onClick={onSubmit} className="affiliation_continue_btn"
                                type="submit">{t('next_btn')}</button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    affiliation: state.affiliation,
    appData: state.appData,
    personalData: state.personalData
});

const mapDispatchToProps = {
    setQuestions,
    setAffiliationField,
    setPersonalData
};

export default connect(mapStateToProps, mapDispatchToProps)(AffiliationInfo);